"use strict";

exports.__esModule = true;
var _OperatorPanelCollection = require("./OperatorPanelCollection");
Object.keys(_OperatorPanelCollection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OperatorPanelCollection[key]) return;
  exports[key] = _OperatorPanelCollection[key];
});
var _OperatorPanelCollectionContext = require("./OperatorPanelCollectionContext");
Object.keys(_OperatorPanelCollectionContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OperatorPanelCollectionContext[key]) return;
  exports[key] = _OperatorPanelCollectionContext[key];
});